export default {
  inserted: function (el, binding) {
    let timer;
    const targetEl = el.tagName === 'INPUT' ? el : el.querySelector('input');
    
    if (!targetEl) return;

    targetEl.addEventListener('input', () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        if (typeof binding.value === 'function') {
          binding.value();
        }
      }, 500);
    });
  },
  unbind: function (el) {
    const targetEl = el.querySelector('input') || el;
  }
};